import { Outlet, useLocation } from 'react-router-dom';
import { createRef, useRef, useState, useEffect, useContext, useLayoutEffect } from 'react';

import Header from '../Header';
import Topbar from '../../navigation/Topbar';

import useAuth from '../../../hooks/useAuth';

import {checkIsIframePage} from '../../../constants/page-control';

const Layout = () => {
    const [isIframe, setIsIframe] = useState(null);
    const [headerElementHeight, setHeaderElementHeight] = useState(0);
    const location = useLocation();
    /* @ts-ignore */
    const { auth } = useAuth();
    const mode = auth.mode;

    useLayoutEffect(() => {
  
    }, []);

    useLayoutEffect(() => {

        //check current page is it iframe page
        setIsIframe(undefined);
        let lastSegment = location.pathname;
        let isIframePage = checkIsIframePage(lastSegment);
        setIsIframe(isIframePage);

    }, [location]);


    useEffect(() => {
        let headerElement = document.getElementsByClassName(
            'top-menu-header-container'
        );
        //console.log(headerElement);
        let offsetHeight = headerElement[0].offsetHeight;
        setHeaderElementHeight(offsetHeight);
        //console.log(offsetHeight);
    }, []);


    useEffect(() => {
        let divElement = document.getElementById('top-menu-page-container');
        divElement.scroll({
            top: 0, //scroll to the bottom of the element
            behavior: 'smooth' //auto, smooth, initial, inherit
        });
    }, [location]);



    return (
        <div className="App">
            <div
                className={'layout-container ' + (mode == 'dark' ? 'dark' : '')}
            >
                <div className="main-container fluid-container overflow-hidden">
                    <div className="row top-menu-header-container">
                        <Header />
                        <Topbar />
                    </div>
                    <div
                        id="top-menu-page-container"
                        className="row top-menu-page-container mt-1 "
                        style={{
                            position: 'relative',
                            height: `calc(100vh - ${headerElementHeight}px)`
                        }}
                    >
                   
                        {
                            isIframe == false && (
                                <div
                                    className={
                                        'col-12  ' +
                                        (isIframe == false ? ' pl-4 pr-4 ' : ' ')
                                    }
                                >
                                    <div
                                        className={
                                            'page-content pb-1 ' +
                                            (isIframe == false
                                                ? ' '
                                                : ' iframe-block position-relative')
                                        }
                                    >
                                        <Outlet />
                                    </div>
                                    {isIframe == false && (
                                        <footer className="pb-3">
                                            <div className="footer-container protected">
                                                © 2026
                                            </div>
                                        </footer>
                                    )}
                                </div> // independent iframe to avoid boostrap padding
                            )
                        }

                        {
                            isIframe == true && (
                                <Outlet  />
                            )
                        }
                       
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Layout;
